import script from "./LetterNumbersStep.vue?vue&type=script&setup=true&lang=js"
export * from "./LetterNumbersStep.vue?vue&type=script&setup=true&lang=js"

import "./LetterNumbersStep.vue?vue&type=style&index=0&id=4544b32e&lang=scss"

const __exports__ = script;

export default __exports__